import type { FeatureFlag, Params } from 'stores/FeatureStore';

/**
 * Maps LaunchDarkly feature flag names to their corresponding URL param override names.
 * Only flags that have a URL param override need an entry here.
 * Source of truth derived from MessengerStore computed getters.
 */
export const FEATURE_FLAG_URL_PARAM_MAP: Partial<Record<FeatureFlag, keyof Params>> = {
  ALLOW_170_TEAM_SLOTS: 'allow170TeamSlots',
  ALLOW_ALERT_LIFESPAN: 'allowAlertLifespan',
  ALLOW_CLINICAL_WORKFLOWS: 'allowClinicalWorkflows',
  ALLOW_CONVERSATION_EXPIRATION: 'allowConversationExpiration',
  ALLOW_CUSTOM_FIELDS_ON_SEARCH: 'allowCustomFieldsOnSearch',
  ALLOW_DEBUG_ALLOWED_SENDERS: 'allowDebugAllowedSenders',
  ALLOW_DELEGATION_ALERT_ROUTING: 'allowDelegationAlertRouting',
  ALLOW_DELEGATION_BANNER: 'allowDelegationBanner',
  ALLOW_DELEGATION_ROLE_UNAVAILABLE: 'allowDelegationRoleUnavailable',
  ALLOW_DO_NOT_EXPIRE: 'allowDoNotExpire',
  ALLOW_PERSONA_MESSAGE_TTL_AND_PIN_LOCK: 'allowPersonaMessageTtlAndPinLock',
  ALLOW_SCIM_ADMIN_SETTING: 'allowScimAdminSetting',
  ALLOW_SELF_SERVICE_SAML_CONFIG: 'allowSelfServiceSamlConfig',
  ALLOW_SENTRY_MEMORY_PROFILING: 'allowSentryMemoryProfiling',
  CARE_TEAM_ASSIGNMENTS: 'showCareTeamAssignments',
  COLLAPSIBLE_ROSTER: 'collapsibleRoster',
  ENABLE_FLAG_CONVERSATION: 'enableFlagConversation',
  ENABLE_LOCATIONS: 'enableLocations',
  ENABLE_PIN_CONVERSATION: 'enablePinConversation',
  ENABLE_SUKI: 'enableSuki',
  ENABLE_US_SCIM_DELETION: 'enableUSSCIMdeletion',
  GROUP_ALERTS: 'allowGA',
  GROUP_ALERTS_VIEW_CONVERSATION: 'allowGAVC',
  KEYWORD_INBOX_SEARCH: 'allowKeywordInboxSearch',
  KEYWORD_INBOX_SEARCH_PHASE_2: 'allowKeywordInboxSearchPhase2',
  KIBANA_TRACK_EXPIRE_SESSION: 'kibanaTrackExpireSession',
  NEW_CONVERSATION_UI: 'allowNewConversationUI',
  NO_SEARCH_RESULTS_ON_EMPTY_QUERY: 'noSearchResultsOnEmptyQuery',
  OTP_LOGIN: 'allowOTP',
  PBX_ROLES: 'allowPBXRoles',
  PATIENT_BANNER_SETTING: 'allowPatientBannerSetting',
  READ_MOUSE_ACTIVITY_LOGOUT: 'readMouseActivityLogout',
  ROLES_PERFORMANCE: 'allowRolesPerformance',
  RTU: 'allowRTU',
  SHOW_PBX_DIRECTORY: 'showPbxDirectory',
  UT: 'allowUT',
};
